import { useMutation } from 'react-query'
import { ApiService } from '../../api'
import { queryClient } from '../../react-query-provider'

export const useDeleteRedirect = () => {
  const { destroy } = ApiService.Redirects.hooks()

  return useMutation(({ id }: { id: number }) => destroy(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(['redirects'])
    }
  })
}
